import React, { useEffect, useState } from "react";
import Pagination from "src/components/Pagination/Pagination";
import useControlPanel from "src/hooks/useControlPanel";
import useDebounce from "src/hooks/useDebounce";
import ControlPanelSystem from "src/components/controlPanelSystem/ControlPanelSystem";
import TTSEventPanelOptional from "../../components/ControlPanel/PanelOptional/TTSEventPanelOptional";
import { useGetPermissionAccessControl } from "src/context/PermissionAccessControl";
import TTSEventPopup from "../../components/Popup/TTSEventPopup";
import TTSEventControlPanel from "../../components/ControlPanel/TTSEventControlPanel";
import TTSEventTable from "../../components/Table/TTSEventTable";
import { path } from "src/constants/path";
import {
  createTTSEvent,
  getTTSEvent,
  removeTTSEvent,
  updateTTSEvent,
} from "src/apis/TTS/event.api";
import { isOpenPopup } from "../../utils";
import { NotifyConfirm } from "src/components/notify/Notify";

const initEventData = {
  list: [],
  total_record: 0,
};

const titlePage = "TTS Event";

const TTSEvent = () => {
  const permissionsAccessControl = useGetPermissionAccessControl();

  const {
    page,
    searchKey,
    numberPage,
    setNumberPage,
    limit,
    setLimit,
    status,
    setStatus,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    handleInputChange,
    handleChangePage,
  } = useControlPanel();

  const [eventData, setEventData] = useState(initEventData);
  const [filterEvents, setFilterEvents] = useState([]);

  const [recordForEdit, setRecordForEdit] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [eventType, setEventType] = useState("success");

  const [errorsForm, setErrorsForm] = useState({});
  let search = useDebounce(searchKey, 500);

  useEffect(() => {
    const query = {
      page: numberPage,
      limit,
      searchKey: search,
      eventType,
      startDate,
      endDate,
      status,
    };
    getTTSEvent(query, (result) => {
      setEventData({ ...result });
      setFilterEvents([...result.list]);
    });
  }, [endDate, eventType, limit, numberPage, search, startDate, status]);

  useEffect(() => {
    setNumberPage(page);
  }, [page, setNumberPage, status, eventType]);

  const actionAfterCreateOrUpdate = (result, resetForm) => {
    if (result.data?.status === 422) {
      setErrorsForm({ ...result.data.data });
    } else {
      getTTSEvent({ eventType }, (result) => {
        setEventData({ ...result });
        setFilterEvents([...result.list]);
      });
      resetForm();
      handleOpenPopup(!isOpenPopup, null);
    }
  };

  const addOrEdit = (event, resetForm) => {
    if (!event.id) {
      createTTSEvent(event, (result) => {
        actionAfterCreateOrUpdate(result, resetForm);
      });
    } else {
      updateTTSEvent(event.id, event, (result) => {
        actionAfterCreateOrUpdate(result, resetForm);
      });
    }
  };

  const handleDelete = (eventDeleted) => {
    NotifyConfirm("warning", "Are you delete it ?", (result) => {
      if (result.isConfirmed) {
        const foundEventIndex = eventData.list.findIndex(
          (intent) => intent.id === eventDeleted.id
        );
        if (foundEventIndex !== -1) {
          removeTTSEvent(eventDeleted.id);
          eventData.list.splice(foundEventIndex, 1);
          setEventData((prev) => {
            return {
              ...prev,
              list: [...eventData.list],
              total_record: prev.total_record - 1,
            };
          });
          setFilterEvents([...eventData.list]);
        }
      }
    });
  };

  const handleOpenPopup = (isOpen, item) => {
    setOpenPopup(isOpen);
    setRecordForEdit(item);
    setErrorsForm({});
  };

  return (
    <div>
      <div className="page-header">
        <h2>{titlePage}</h2>
      </div>

      <TTSEventPopup
        recordForEdit={recordForEdit}
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
        addOrEdit={addOrEdit}
        errorsForm={errorsForm}
        eventType={eventType}
      />

      <TTSEventControlPanel
        permissionsAccessControl={permissionsAccessControl}
        handleOpenPopup={handleOpenPopup}
      >
        <ControlPanelSystem
          searchKey={searchKey}
          handleInputChange={(e) => handleInputChange(e)}
          limit={limit}
          setLimit={setLimit}
          setNumberPage={setNumberPage}
          status={status}
          setStatus={setStatus}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
        />
        <TTSEventPanelOptional
          eventType={eventType}
          setEventType={setEventType}
        />
      </TTSEventControlPanel>

      <TTSEventTable
        permissionsAccessControl={permissionsAccessControl}
        data={filterEvents}
        handleOpenPopup={handleOpenPopup}
        handleDelete={handleDelete}
        status={status}
      />

      <Pagination
        pathname={path.ttsEvent}
        page={numberPage}
        handleChangePage={(page) => handleChangePage(page)}
        limit={limit}
        pageSize={eventData.total_record}
      />
    </div>
  );
};

export default TTSEvent;
